

export function LoadSpeak()
{
    var voiceSelect = document.getElementById('voice');
var spanish;
var mexico="0";
    function loadVoices() {
        // Fetch the available voices.
          var voices = speechSynthesis.getVoices();
        
        // Loop through each of the voices.
          voices.forEach(function(voice, i) {
          // Create a new option element.
              var option = document.createElement('option');
          if(voice.name.toLowerCase().indexOf("spa") !== -1)
          {
            spanish = voice.name;
          }
          if(voice.name.toLowerCase().indexOf("mex") !== -1)
          {
            mexico = voice.name;
          }
        //   else if(voice.name.indexOf("Spa") !== -1){
        //     spanish = voice.name;
        //   }
          // Set the options value and text.
              option.value = voice.name;
              option.innerHTML = voice.name;
                {/* <MenuItem value={10}>Ten</MenuItem> */}
                
          // Add the option to the voice selector.
              voiceSelect.appendChild(option);
          });
      }
    if(mexico!="0")
    {
        alert("mex");
        spanish=mexico;
    }
        // Execute loadVoices.
      loadVoices();
      // Chrome loads voices asynchronously.
        window.speechSynthesis.onvoiceschanged = function(e) {
            loadVoices();
            if(mexico!="0")
            {
                spanish=mexico;
            }
            document.getElementById('voice').value=spanish;
        };
        if(mexico!="0")
        {
            spanish=mexico;
        }
        document.getElementById('voice').value=spanish;
}
//LoadSpeak();




// export function LoadSpeakAll()
// {
//     var voiceSelect = document.getElementById('voice');
// var spanish;
// var mexico="0";
//     function loadVoices() {
//         // Fetch the available voices.
//           var voices = speechSynthesis.getVoices();     
//         // Loop through each of the voices.
//           voices.forEach(function(voice, i) {
//           // Create a new option element.
//               var option = document.createElement('option');


//               option.value = voice.name;
//               option.innerHTML = voice.name;
                
//           // Add the option to the voice selector.
//               voiceSelect.appendChild(option);
//           });
//       }
//       loadVoices();
//       // Chrome loads voices asynchronously.
//         window.speechSynthesis.onvoiceschanged = function(e) {
//             loadVoices();
//             if(mexico!="0")
//             {
//                 spanish=mexico;
//             }
//             document.getElementById('voice').value=spanish;
//         };
//         document.getElementById('voice').value=spanish;
// }










document.addEventListener("DOMContentLoaded", function(event) { 
  //LoadSpeak();


});